import { defineType } from "sanity";

import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  type: "object",
  name: "faqQuestion",
  title: "FAQ Question",
  preview: {
    select: {
      title: "question"
    },
    prepare({ title }) {
      return { title: multilingualStringPreview(title) };
    }
  },
  fields: [
    {
      name: "question",
      title: "Question",
      type: "multilingualArrayText",
      validation: (Rule) => Rule.required()
    },
    {
      name: "answer",
      title: "Answer",
      type: "multilingualArrayBlockContent",
      validation: (Rule) => Rule.required()
    }
  ]
});
